export const AfterPaymentActionEnum = {
  CONFIRMATION: 'confirmation',
  CHECKOUT: 'checkout',
  REDIRECT: 'redirect',
};
